import { render, staticRenderFns } from "./superannuation-nonSuper-tool.vue?vue&type=template&id=ed2a681a&%3Aclass=%24style%5B'adl-non-super'%5D"
import script from "./superannuation-nonSuper-tool.vue?vue&type=script&lang=js"
export * from "./superannuation-nonSuper-tool.vue?vue&type=script&lang=js"
import style0 from "./superannuation-nonSuper-tool.vue?vue&type=style&index=0&id=ed2a681a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports